
import { createMuiTheme } from '@material-ui/core/styles';

export const THEME = createMuiTheme({
    palette: {
        primary: {
            main: "#004e8e",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#df1913",
            contrastText: "#ffffff",
        },
        info: {
            main: "#ffffff",
            contrastText: "#ffffff",

        }

    },

});